<template>
  <div>
    <section>
      <div class="inner row5">
        <div class="title mobileCenter">
          <h1>기술수용 코호트 <br class="mobileBlock" />(설문조사)</h1>
        </div>
        <section>
          <div class="row4">
            <div class="topContent flex mgT20M">
              <div class="left flex mobileReset">
                <p>
                  총 <span>{{ totalCnt }}</span
                  >건
                </p>
                <p>현재 페이지 {{ currentPage }} / {{ totalPage }}</p>
              </div>
              <div class="flex mWd100 searchCommonBox">
                <input
                  type="text"
                  class="searchInput"
                  v-model="searchText"
                  @keyup.enter="onClickSearch"
                />
                <input
                  type="button"
                  value="검 색"
                  class="searchBtn searchBtnCmmn"
                  @click="onClickSearch"
                />
                <input
                  type="button"
                  value="검색초기화"
                  class="searchResetBtn searchBtnCmmn mobileReset"
                  @click="onClickReset"
                />
              </div>
            </div>
            <div class="mobileBlock totalCount">
              <p>
                총 <span class="colorRed">{{ totalCnt }}</span
                >건
              </p>
            </div>
            <div class="tableContainer">
              <div class="sampleTemplate surveyMobileTable">
                <b-table
                  ref="table"
                  :fields="fields"
                  :items="getItems"
                  :per-page="perPage"
                  :current-page="currentPage"
                  @row-clicked="onClickRow"
                  hover
                >
                  <template #cell(INDEX)="data">
                    {{ data.index + 1 }}
                  </template>

                  <template #cell(STATUS)="data">
                    <span v-html="getStatus(data.item)"></span>
                  </template>
                </b-table>

                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCnt"
                  :per-page="perPage"
                  aria-controls="table"
                >
                </b-pagination>
              </div>
              <CustomerModalSurvey
                v-if="isShowModalSurvey"
                v-bind:surveyIdx="detailSurveyIdx"
                v-bind:isSubmited="detailIsSubmited"
                @modal-closed="handleModalClosed"
              />
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import CustomerModalSurvey from "@/components/survey/customer/ModalSurvey";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Survey",
  components: {
    CustomerModalSurvey,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalCnt: 0,
      sortBy: "IDX",
      sortDesc: false,
      searchText: "",
      fields: [
        {
          // virtual column
          key: "ROWNUM",
          label: "No",
          class: "text-center",
        },
        {
          // virtual column
          key: "STATUS",
          label: "상태",
          isActive: true,
          class: "statusOn text-center",
        },
        {
          key: "TITLE",
          label: "설문 제목",
          class: "text-center",
          formatter(value) {
            if (value.length > 30) {
              return value.substring(0, 30) + "...";
            } else return value;
          },
        },
        {
          key: "INTRODUCTION",
          label: "설문지 설명",
          class: "text-center",
          formatter(value) {
            if (value.length > 50) {
              return value.substring(0, 50) + "..";
            } else return value;
          },
        },
        {
          key: "REGDATE",
          label: "등록일",
          class: "text-center",
        },
        {
          key: "ANSWER_REGDATE",
          label: "제출일",
          class: "text-center",
          formatter(value, key, item) {
            if (item.ANSWER_STATUS === "T") return "";
            else return value;
          },
        },
      ],
      isShowModalSurvey: false,
      detailSurveyIdx: null, // 등록: null, 수정: survey idx
      detailIsSubmited: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
    totalPage() {
      if (this.totalCnt == 0) return 1;
      else if (this.totalCnt % this.perPage == 0)
        return this.totalCnt / this.perPage;
      else return Math.floor(this.totalCnt / this.perPage) + 1;
    },
  },
  methods: {
    ...mapActions("survey", ["requestListForCustomer"]),
    getItems() {
      const user = this.getUser;
      var target = "";
      switch (user.roleName) {
        case this.$role.USER:
          target = "USER";
          break;
        case this.$role.CORP:
          target = "CORP";
          break;
        default:
          target = "ALL";
          break;
      }

      return this.requestListForCustomer({
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        searchText: this.searchText,
        period: "STARTED",
        target: target,
        userIdx: user.idx,
      })
        .then((response) => {
          const items = response.data.items;
          this.totalCnt = response.data.totalCnt;

          return items;
        })
        .catch((error) => {
          console.log(error);
          this.$alert("알림", "설문지 조회에 실패했습니다.");
          return [];
        });
    },
    getStatus(item) {
      const status = item.ANSWER_STATUS;
      if (status === "F") {
        return "제출";
      } else {
        if (item.END_DATE != null && item.END_DATE != "") {
          var today = new Date();
          var endDate = new Date(item.END_DATE + " 23:59:59");

          if (today.getTime() > endDate.getTime()) {
            return '<span class="notSubmit">만료</span>';
          }
        }

        return '<span class="notSubmit">미제출</span>';
      }
    },
    onClickRow(item) {
      this.detailIsSubmited = item.ANSWER_STATUS === "F" ? true : false;
      this.detailSurveyIdx = item.IDX;
      this.isShowModalSurvey = true;
    },
    onClickSearch() {
      this.$refs.table.refresh();
    },
    onClickReset() {
      this.perPage = 10;
      this.currentPage = 1;
      this.totalCnt = 0;
      this.sortBy = "IDX";
      this.sortDesc = false;
      this.searchText = "";

      this.$refs.table.refresh();
    },
    handleModalClosed(value, param) {
      if (value === CustomerModalSurvey.name) {
        this.isShowModalSurvey = false;

        if (param.result == true) {
          this.$refs.table.refresh();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.sampleTemplate ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
</style>
